const LOCAL_FRONTEND_HOSTS = new Set(['localhost', '127.0.0.1']);

export function resolveApiBaseUrl(localDevUrl = 'http://localhost:8000'): string {
  if (typeof window === 'undefined') {
    return localDevUrl;
  }

  const { hostname, port } = window.location;
  const isLocalAngularDevHost = LOCAL_FRONTEND_HOSTS.has(hostname) && port === '4200';
  if (isLocalAngularDevHost) {
    return localDevUrl;
  }

  // In deployed environments, use the same origin so browsers do not try to call their own localhost.
  return '';
}
